export const REVIEWS_FETCHED = 'REVIEWS_FETCHED';
export const REVIEW_FETCHED = 'REVIEW_FETCHED';
export const REVIEW_ANNOTATIONS_FETCHED = 'REVIEW_ANNOTATIONS_FETCHED';
export const REVIEW_ADD = 'REVIEW_ADD';
export const REVIEW_UPDATE = 'REVIEW_UPDATE';
export const REVIEW_REMOVE = 'REVIEW_REMOVE';
export const REVIEWS_UPDATE_PENDING_COUNT = 'REVIEWS_UPDATE_PENDING_COUNT';
export const REVIEWS_UPDATE_PENDING_COUNT_BY_PLACE = 'REVIEWS_UPDATE_PENDING_COUNT_BY_PLACE';
export const REVIEWS_UPDATE_PENDING_COUNT_BY_USER = 'REVIEWS_UPDATE_PENDING_COUNT_BY_USER';
